const _temp0 = require("./_config.styl");
const _temp1 = require("./a.styl");
const _temp2 = require("./body.styl");
const _temp3 = require("./header.styl");
const _temp4 = require("./input.styl");
const _temp5 = require("./label.styl");
const _temp6 = require("./main.styl");
const _temp7 = require("./nav.styl");
const _temp8 = require("./select.styl");
const _temp9 = require("./table.styl");
const _temp10 = require("./textarea.styl");
module.exports = {
  "_config": _temp0,
  "a": _temp1,
  "body": _temp2,
  "header": _temp3,
  "input": _temp4,
  "label": _temp5,
  "main": _temp6,
  "nav": _temp7,
  "select": _temp8,
  "table": _temp9,
  "textarea": _temp10
}